import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row } from "react-bs4grid";
import { withRouter } from "react-router-dom";
import { Form, Formik } from "formik";
import objectToFormData from "object-to-formdata";
import { pickBy, merge } from "lodash";

import TextField from "../../common/formiks/TextField/TextField";
import editProfileFormValidationSchema from "./editProfileFormValidationSchema";
import PhoneNumberInputField from "../../common/formiks/PhoneNumberInputField/PhoneNumberInputField";
import AppContainer from "../AppContainer/AppContainer";
import axiosInstance from "../../apiPromises/axiosInstance";
import ImageUploadField from "../../common/formiks/ImageUploadField/ImageUploadField";

import "react-phone-number-input/style.css";
import "./editProfileOverrides.scss";
import {useTranslation} from "react-i18next";

function EditProfile({ history }) {
  const {t} = useTranslation();
  const [userProfile, setUserProfile] = useState({});

  useEffect(() => {
    axiosInstance.get("/users/current").then(res => {
      setUserProfile(res.data);
    });
  }, []);
  return (
    <AppContainer>
      {userProfile.userId && (
        <Fragment>
          <Container>
            <div className="pt-32">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center"
                }}
              >
                <h1>{t("editAccount")}</h1>
                <Formik
                  validationSchema={editProfileFormValidationSchema}
                  initialValues={{
                    email: userProfile.email,
                    password: "",
                    repeatPassword: "",
                    firstName: userProfile.firstName,
                    lastName: userProfile.lastName,
                    profilePhotoFile: {},
                    phoneNationalNumber: userProfile.phoneNationalNumber,
                    location: ""
                  }}
                  onSubmit={(values, formikActions) => {
                    const prunedValues = merge(userProfile, pickBy(values));
                    if (values.phoneNationalNumber) {
                      prunedValues.phoneCountryCode = values.phoneNationalNumber.substr(
                        0,
                        3
                      );
                    }
                    if (values.phoneNationalNumber) {
                      prunedValues.phoneNationalNumber = values.phoneNationalNumber.substr(
                        3
                      );
                    }
                    if (values.location) {
                      prunedValues.location = values.location;
                    }
                    const bodyFormData = objectToFormData(prunedValues);
                    bodyFormData.append(
                      "profilePhotoFile",
                      prunedValues.profilePhotoFile
                    );
                    axiosInstance({
                      method: "put",
                      url: "/users/current",
                      config: {
                        headers: { "Content-Type": "multipart/form-data" }
                      },
                      data: bodyFormData
                    })
                      .then(() => {
                        history.push("/user/my-profile");
                      })
                      .catch(error => {
                        formikActions.setFieldError(
                          "password",
                          error.response.data.errorMessage
                        );
                        formikActions.setSubmitting(false);
                      });
                  }}
                  render={({ errors, values, isSubmitting }) => {
                    console.log(errors);
                    return (
                      <Form autoComplete="off">
                        <Container>
                          <Row>
                            <Col>
                              <ImageUploadField
                                label="  "
                                name="profilePhotoFile"
                                placeholder={
                                  userProfile.profilePhotoPath ||
                                  "/default-profile-picture.jpg"
                                }
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                label={t("firstName")}
                                name="firstName"
                                type="text"
                                placeholder={t("firstName")}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                label={t("lastName")}
                                name="lastName"
                                type="text"
                                placeholder={t("lastName")}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <PhoneNumberInputField
                                name="phoneNationalNumber"
                                label={t("phoneNumber")}
                                placeholder={t("phoneNumber")}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                label={t("email")}
                                name="email"
                                type="email"
                                placeholder={t("email")}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextField
                                label={t("location")}
                                name="location"
                                placeholder={t("location")}
                              />
                            </Col>
                          </Row>
                          <Row className="invisible">
                            <Col>
                              <TextField
                                label={t("password")}
                                name="password"
                                type="password"
                                placeholder="********"
                              />
                            </Col>
                          </Row>
                          <Row className="invisible">
                            <Col>
                              <TextField
                                label={t("password")}
                                name="repeatPassword"
                                type="password"
                                placeholder="********"
                              />
                            </Col>
                          </Row>
                          <Row className="pb-64">
                            <Col>
                              <button
                                className="btn btn-primary"
                                disabled={isSubmitting}
                                type="submit"
                              >
                                {t("confirm")}
                              </button>
                            </Col>
                          </Row>
                        </Container>
                      </Form>
                    );
                  }}
                />
              </div>
            </div>
          </Container>
        </Fragment>
      )}
    </AppContainer>
  );
}

export default withRouter(EditProfile);
